var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-section" }, [
    _c("div", { staticClass: "emd-container" }, [
      _c(
        "div",
        { staticClass: "emd-container__header eu-py_4_md eu-px_5_md" },
        [
          _c("h2", { staticClass: "emd-text _size_section _color_default" }, [
            _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
          ]),
        ]
      ),
      _c("hr", { staticClass: "emd-divider" }),
      _c(
        "div",
        { staticClass: "emd-container__content eu-pa_5_md" },
        [
          _vm.tabbarError.status && _vm.isCustomerValid
            ? _c("emd-alert", {
                attrs: {
                  variant: "danger",
                  title: _vm.$t("tabbarError.customer"),
                  autoclose: "",
                },
                on: {
                  cancel: function ($event) {
                    _vm.tabbarError.status = false
                  },
                },
              })
            : _vm._e(),
          _c("form", { attrs: { action: "" } }, [
            _c("div", { staticClass: "eu-flex eu-column eu-row_md" }, [
              _c("div", { staticClass: "eu-flex-item eu-basis_6_md" }, [
                _c("div", { staticClass: "emd-form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "emd-label _required",
                      attrs: { for: "name" },
                    },
                    [_vm._v(_vm._s(_vm.$t("name")))]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.customer.name,
                        expression: "customer.name",
                      },
                    ],
                    staticClass: "emd-input",
                    class: {
                      _state_error:
                        _vm.$v.customer.name.$invalid &&
                        _vm.showFeedbacks.status,
                    },
                    attrs: { type: "text", name: "name", id: "name" },
                    domProps: { value: _vm.customer.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.customer, "name", $event.target.value)
                      },
                    },
                  }),
                  !_vm.$v.customer.name.maxLength && _vm.showFeedbacks.status
                    ? _c(
                        "p",
                        { staticClass: "emd-input-feedback _state_error" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("hint.length", { length: "64" })) +
                              " "
                          ),
                        ]
                      )
                    : _vm.$v.customer.name.$invalid && _vm.showFeedbacks.status
                    ? _c(
                        "p",
                        { staticClass: "emd-input-feedback _state_error" },
                        [_vm._v(" " + _vm._s(_vm.$t("hint.required")) + " ")]
                      )
                    : _vm._e(),
                ]),
              ]),
              _c("div", { staticClass: "eu-flex-item eu-basis_6_md" }, [
                _c("div", { staticClass: "emd-form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "emd-label _required",
                      attrs: { for: "email" },
                    },
                    [_vm._v(_vm._s(_vm.$t("email")))]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.customer.email,
                        expression: "customer.email",
                      },
                    ],
                    staticClass: "emd-input",
                    class: {
                      _state_error:
                        _vm.$v.customer.email.$invalid &&
                        _vm.showFeedbacks.status,
                    },
                    attrs: { type: "email", name: "email", id: "email" },
                    domProps: { value: _vm.customer.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.customer, "email", $event.target.value)
                      },
                    },
                  }),
                  !_vm.$v.customer.email.maxLength && _vm.showFeedbacks.status
                    ? _c(
                        "p",
                        { staticClass: "emd-input-feedback _state_error" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("hint.length", { length: "64" })) +
                              " "
                          ),
                        ]
                      )
                    : _vm.$v.customer.email.$invalid && _vm.showFeedbacks.status
                    ? _c(
                        "p",
                        { staticClass: "emd-input-feedback _state_error" },
                        [_vm._v(" " + _vm._s(_vm.$t("hint.required")) + " ")]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "eu-flex eu-column eu-row_md" }, [
              _c("div", { staticClass: "eu-flex-item eu-basis_6_md" }, [
                _c(
                  "div",
                  { staticClass: "emd-form-group" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "emd-label",
                        class: {
                          _required: _vm.isBoleto || _vm.isPSP || _vm.isPix,
                        },
                        attrs: { for: "document" },
                      },
                      [_vm._v(_vm._s(_vm.$t("document.label")))]
                    ),
                    _c("the-mask", {
                      staticClass: "emd-input",
                      class: {
                        _state_error:
                          _vm.$v.customer.document.$invalid &&
                          _vm.showFeedbacks.status,
                      },
                      attrs: {
                        type: "tel",
                        name: "document",
                        id: "document",
                        mask: ["###.###.###-##", "##.###.###/####-##"],
                      },
                      model: {
                        value: _vm.customer.document,
                        callback: function ($$v) {
                          _vm.$set(_vm.customer, "document", $$v)
                        },
                        expression: "customer.document",
                      },
                    }),
                    _c("p", { staticClass: "emd-input-feedback" }, [
                      _vm._v(_vm._s(_vm.$t("document.hint"))),
                    ]),
                    _vm.$v.customer.document.$invalid &&
                    _vm.showFeedbacks.status &&
                    (_vm.isBoleto || _vm.isPSP || _vm.isPix) &&
                    !_vm.customer.document.length
                      ? _c(
                          "p",
                          { staticClass: "emd-input-feedback _state_error" },
                          [_vm._v(" " + _vm._s(_vm.$t("hint.required")) + " ")]
                        )
                      : _vm._e(),
                    _vm.$v.customer.document.$invalid &&
                    _vm.showFeedbacks.status &&
                    _vm.customer.document.length
                      ? _c(
                          "p",
                          { staticClass: "emd-input-feedback _state_error" },
                          [_vm._v(" " + _vm._s(_vm.$t("hint.document")) + " ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "eu-flex-item eu-basis_3_md" }, [
                _c(
                  "div",
                  { staticClass: "emd-form-group" },
                  [
                    _c(
                      "label",
                      {
                        class: [
                          "emd-label",
                          {
                            _required: _vm.contactNumberIsRequired || _vm.isPix,
                          },
                        ],
                        attrs: { for: "cellphone" },
                      },
                      [_vm._v(_vm._s(_vm.$t("cellphone")))]
                    ),
                    _c("the-mask", {
                      staticClass: "emd-input",
                      class: {
                        _state_error:
                          _vm.$v.customer.mobile_phone.$invalid &&
                          _vm.showFeedbacks.status,
                      },
                      attrs: {
                        type: "tel",
                        name: "cellphone",
                        id: "cellphone",
                        placeholder: "21 00000-0000",
                        mask: ["## #####-####"],
                      },
                      model: {
                        value: _vm.customer.mobile_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.customer, "mobile_phone", $$v)
                        },
                        expression: "customer.mobile_phone",
                      },
                    }),
                    _vm.$v.customer.mobile_phone.$invalid &&
                    _vm.showFeedbacks.status &&
                    !_vm.$v.customer.mobile_phone.minLength
                      ? _c(
                          "p",
                          { staticClass: "emd-input-feedback _state_error" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("hint.mobile_phone")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.$v.customer.mobile_phone.$invalid &&
                    _vm.showFeedbacks.status
                      ? _c(
                          "p",
                          { staticClass: "emd-input-feedback _state_error" },
                          [_vm._v(" " + _vm._s(_vm.$t("hint.phone")) + " ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "eu-flex-item eu-basis_3_md" }, [
                _c(
                  "div",
                  { staticClass: "emd-form-group" },
                  [
                    _c(
                      "label",
                      {
                        class: [
                          "emd-label",
                          { _required: _vm.contactNumberIsRequired },
                        ],
                        attrs: { for: "telephone" },
                      },
                      [_vm._v(_vm._s(_vm.$t("telephone")))]
                    ),
                    _c("the-mask", {
                      staticClass: "emd-input",
                      class: {
                        _state_error:
                          _vm.$v.customer.home_phone.$invalid &&
                          _vm.showFeedbacks.status,
                      },
                      attrs: {
                        type: "tel",
                        name: "telephone",
                        id: "telephone",
                        placeholder: "21 00000-0000",
                        mask: ["## ####-####"],
                      },
                      model: {
                        value: _vm.customer.home_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.customer, "home_phone", $$v)
                        },
                        expression: "customer.home_phone",
                      },
                    }),
                    _vm.$v.customer.home_phone.$invalid &&
                    _vm.showFeedbacks.status &&
                    !_vm.$v.customer.home_phone.minLength
                      ? _c(
                          "p",
                          { staticClass: "emd-input-feedback _state_error" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("hint.home_phone")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.$v.customer.home_phone.$invalid &&
                    _vm.showFeedbacks.status
                      ? _c(
                          "p",
                          { staticClass: "emd-input-feedback _state_error" },
                          [_vm._v(" " + _vm._s(_vm.$t("hint.phone")) + " ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _c("section", { staticClass: "el-section" }, [
              _c("div", { staticClass: "el-chunk" }, [
                _c("div", { staticClass: "emd-form-box__header" }, [
                  _c(
                    "label",
                    {
                      staticClass: "emd-checkbox",
                      attrs: { for: "showaddress" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.address.show_address,
                            expression: "address.show_address",
                          },
                        ],
                        staticClass: "emd-checkbox__input",
                        attrs: {
                          name: "showaddress",
                          type: "checkbox",
                          id: "showaddress",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.address.show_address)
                            ? _vm._i(_vm.address.show_address, null) > -1
                            : _vm.address.show_address,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.address.show_address,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.address,
                                    "show_address",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.address,
                                    "show_address",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.address, "show_address", $$c)
                            }
                          },
                        },
                      }),
                      _c("div", { staticClass: "emd-checkbox__area" }),
                      _c("span", { staticClass: "eu-ml_2" }, [
                        _vm._v(_vm._s(_vm.$t("address.checkbox"))),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "emd-form-box",
                  class: {
                    _active: _vm.address.show_address,
                    _border_base: _vm.address.show_address,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "emd-form-box__content" },
                    [
                      _c("address-form", {
                        attrs: { address: _vm.address },
                        on: {
                          toggle: _vm.toggleAddressFormState,
                          addressIsLoading: _vm.toggleLoadingAddress,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "el-section" }, [
      _c(
        "div",
        {
          staticClass:
            "eu-display_flex eu-justify_space-between eu-wrap_reverse",
        },
        [
          _c(
            "button",
            {
              staticClass: "emd-btn _color_secondary _type_text _block_mobile",
              attrs: { disabled: _vm.loadingAddress },
              on: { click: _vm.reverseRoute },
            },
            [
              _c("i", { staticClass: "uil uil-angle-left" }),
              _vm._v(" " + _vm._s(_vm.$t(_vm.previousRoute)) + " "),
            ]
          ),
          _c(
            "button",
            {
              staticClass:
                "emd-btn _color_secondary _block_mobile eu-mb_5 eu-no-margin_sm",
              attrs: { disabled: _vm.loadingAddress },
              on: { click: _vm.nextRoute },
            },
            [
              _vm._v(" " + _vm._s(_vm.$t("PaymentData")) + " "),
              _c("i", { staticClass: "uil uil-angle-right" }),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }